import Vue from "vue";
import stringClear from "../directives/stringClear";
import clipboard from "../directives/clipboard";

Vue.directive("stringscaped", stringClear);
Vue.directive("copy", clipboard);
